<template>
  <div>
    <v-row align="center">
      <v-icon>mdi-book-open-blank-variant</v-icon>
      <div>{{ $t("story.genre") }}</div>
    </v-row>
    <v-row>
    <v-autocomplete
      v-model="genre"
      :items="genres"
      :label="$t('story.basicInfoForm.selectAGenre')"
      single-line
      outlined
      item-text="_id"
      item-value="id"
      solo
    />
    </v-row>
  </div>
</template>
<script>
import gql from "graphql-tag";
export default {
  props: {
    value: String,
  },
  data() {
    return {
      genre: this.value,
    };
  },
  watch: {
    genre(newValue) {
      this.$emit("input", newValue);
      if (this.genres) {
        this.$emit("genreObject", this.genres.filter( (genre) => genre.id == newValue)[0])
      }
    },
    value(newValue) {
      if (this.genre != newValue) {
        this.genre = newValue;
      }
    },
  },
  apollo: {
    genres: {
      query: gql`
        query {
          storyGenres {
            _id
            id
          }
        }
      `,
      update(data) {
        return data.storyGenres;
      },
    },
  },
};
</script>